import { ApiService, toModels } from '~/shared/api'
import { AgreementsDocument } from '~/models/agreements'
import { API_PREFIX } from '~/shared/const/request-services'
import type { AgreementsDocumentsListParams } from '~/shared/types/agreements'

export class AgreementsDocumentsService extends ApiService {
  readonly url = `${API_PREFIX}/agreements/documents`

  getListModel(params: AgreementsDocumentsListParams = {}): Promise<AgreementsDocument[]> {
    return this.http.request({ url: this.url, params }).then(toModels(AgreementsDocument))
  }

  getActualDocuments(): Promise<AgreementsDocument[]> {
    return this.getListModel({ include: 'versions,versions.file', 'page[size]': 50 })
  }
}
